<template lang="pug">
  .box-header(:class="{info: alternateMode}")

    .row

      .left-container.col-lg-4.col-xl-3

        label.md-check.m-r-sm(v-if="checkbox")
          input(
            type="checkbox"
            v-model="checkboxValue"
            @change="onCheckboxInput"
          )
          i.indigo

        input.form-control(
          autofocus
          :disabled="disabled"
          type="search"
          placeholder="Search..."
          slot="search"
          v-model="query"
          @input="onQueryInput"
        )

      .col-lg-8.col-xl-9.text-right(slot="actions")

        datatable-header-actions(
          :actions="actions"
          :alternate-mode="alternateMode"
          :disabled="disabled"
          :selected-count="selectedCount"
          @clear="onCleared"
        )
</template>

<script>
import DatatableHeaderActions from './datatable-header-actions';

export default {
    components: {
        DatatableHeaderActions,
    },

    props: {
        actions: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },

        alternateMode: {
            type: Boolean,
            required: false,
            default: false,
        },

        checkbox: {
            type: Boolean,
            required: false,
            default: false,
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },

        selectedCount: {
            type: Number,
            required: false,
            default: 1,
        },
    },

    data() {
        return {
            checkboxValue: false,
            query: null,
        };
    },

    watch: {
        selectedCount(v) {
            if (v === 0) {
                this.onCleared();
            }
        },
    },

    methods: {
        onCheckboxInput() {
            if (this.checkboxValue) {
                this.$emit('select-all');
            } else {
                this.onCleared();
            }
        },

        onCleared() {
            this.$emit('clear');
        },

        onQueryInput() {
            this.$emit('input', this.query);
        },
    },
};
</script>

<style lang="scss">
.left-container {
    align-items: center;
    display: flex;
}

.info {
    .md-check > i:before {
        border-color: white;
    }

    .md-check > i {
        background-color: white;
    }

    .md-check input[type='checkbox']:checked + i:after {
        color: #6887ff;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/datatable-header/datatable-header.vue